import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '../../core-ui/Icons/Icons.module';
import { InactiveFeatureTooltipContentComponent } from './InactiveFeatureTooltipContent.component';
import { TooltipDirective } from './Tooltip.directive';
import { TooltipContentComponent } from './TooltipContent.component';
import { TooltipOnClickDirective } from './TooltipOnClick.directive';

export const TooltipModuleExports = [
    TooltipContentComponent,
    TooltipDirective,
    TooltipOnClickDirective,
    InactiveFeatureTooltipContentComponent
];

@NgModule({
    imports: [CommonModule, IconsModule],
    declarations: [...TooltipModuleExports],
    exports: [...TooltipModuleExports],
    providers: []
})
export class TooltipModule {}
